import {Typography} from '@mui/material';

interface ParagraphProps {
  title: React.ReactNode;
  body: React.ReactNode;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  maxWidth?: number | string;
  style?: any;
  titleStyle?: any;
}
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const Paragraph = ({
  title,
  body,
  textAlign,
  maxWidth,
  style,
  titleStyle,
}: ParagraphProps) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{
          ...(titleStyle ? titleStyle : {}),
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: isAppIimjobs ? 'Poppins' : 'Nunito Sans',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
          textAlign: textAlign === 'center' ? 'center' : 'left',
          maxWidth: maxWidth !== undefined ? maxWidth : 'none',
          margin: textAlign === 'center' ? '0 auto' : '0',
          marginBottom: '20px',
          ...(style ? style : {}),
        }}
      >
        {body}
      </Typography>
    </>
  );
};

export default Paragraph;
